import React, { useEffect, useState } from "react";

import API from "../../utils/API";
import Select from "react-select";

const PostingStatusSelect = ({ name, value, onChange }) => {
  const [status, setStatus] = useState(null);

  const [filterValue, setFilterValue] = useState([]);

  const mapValuesToFilters = (value = [], lendersList) => {
    return value.map((item) => {
      const matchedFilter = lendersList.find((source) => source.value === item);
      return matchedFilter || item;
    });
  };

  const changeSelect = (value) => {
    let i,
      values = [];
    for (i = 0; i < value?.length; i++) {
      values.push(value[i].value);
    }
    if (name) {
      onChange(name, values);
      const mappedFilters = mapValuesToFilters(values, status);
      setFilterValue(mappedFilters);
    }
  };

  useEffect(() => {
    API.get("/system/postingstatus").then((response) => {
      let options,
        i,
        optionsList = [];
      if (response.data.data) {
        options = response.data.data;
        for (i = 0; i < options.length; i++) {
          optionsList.push({ value: options[i].id, label: options[i].title });
        }
      }
      const mappedFilters = mapValuesToFilters(value, optionsList);
      setFilterValue(mappedFilters);
      setStatus(optionsList);
    });
  }, []);

  return (
    <Select
      className="react-select-container"
      classNamePrefix="react-select"
      options={status}
      value={filterValue}
      onChange={(value) => changeSelect(value)}
      isMulti
      placeholder="Status"
    />
  );
};

export default PostingStatusSelect;
